{
  "just-now": "Hace un momento",
  "empty-history": "Historial Vacio",
  "just": "ha",
  "minutes": "m",
  "hours": "h",
  "days": "d",
  "actor-action": "{{name}} {{action}}",
  "unknown-action": "hizo una actualización",
  "unknown-actor": "Alguien",
  "desktop-title": "Championship Title · Orden {{code}}",
  "desktop-title-plain": "Championship Title",
  "popover-title": "Notificaciones",
  "clear-all": "Borrar todo",
  "empty-hint": "Aquí aparecerán las actualizaciones de tus compañeros en tus órdenes abiertas.",
  "enable-desktop": "Activar notificaciones de escritorio",
  "desktop-blocked": "Las notificaciones de escritorio están bloqueadas en la configuración de tu navegador.",
  "open-order": "Abrir orden {{code}}",
  "unread-label": "Sin leer",
  "bell-label": "Notificaciones",
  "bell-label-unread": "Notificaciones, {{count}} sin leer",
  "createOrder": "creó una orden",
  "createOrderAssociation": "asoció una partida",
  "createOrderFile": "agregó un archivo",
  "createOrderFileData": "agregó información de archivo",
  "createOrderLedgerAssociation": "agregó una asociación de libro mayor",
  "createOrderLedgerEntry": "agregó una entrada en el libro mayor",
  "createOrderLedgerLink": "agregó un enlace en el libro mayor",
  "createOrderLoan": "agregó un préstamo",
  "createOrderLoanInterest": "agregó un interés",
  "createOrderMortgage": "agregó una hipoteca",
  "createOrderMortgageAssociation": "asoció una partida con una hipoteca",
  "createOrderPolicyEndorsement": "agregó un endoso de póliza",
  "createOrderProperty": "agregó una propiedad",
  "createOrderProration": "agregó un impuesto o prorrateo",
  "deleteOrderArchive": "eliminó un archivo",
  "deleteOrderAssociation": "desasoció una partida",
  "deleteOrderFile": "eliminó un archivo",
  "deleteOrderFileData": "eliminó información de archivo",
  "deleteOrderLedgerAssociation": "eliminó una asociación de libro mayor",
  "deleteOrderLedgerEntry": "eliminó una entrada en el libro mayor",
  "deleteOrderLedgerLink": "eliminó un enlace en el libro mayor",
  "deleteOrderLoan": "eliminó un préstamo",
  "deleteOrderLoanInterest": "eliminó un interés",
  "deleteOrderMortgage": "eliminó una hipoteca",
  "deleteOrderMortgageAssociation": "desasoció una partida de una hipoteca",
  "deleteOrderPolicyEndorsement": "eliminó un endoso de póliza",
  "deleteOrderProperty": "eliminó una propiedad",
  "deleteOrderProration": "eliminó un impuesto o prorrateo",
  "generateOrderFiles": "regeneró archivos",
  "helpOrderByAI": "creó una orden con ayuda de inteligencia artificial",
  "helpOrderChargesByAI": "importó cargos con ayuda de inteligencia artificial",
  "helpOrderCharges": "usó el asistente para modificar cargos",
  "helpOrderLedgerEntryLinked": "usó el asistente para enlazar una entrada en el libro mayor",
  "helpOrderLedgerPayeePayer": "usó el asistente para establecer información del beneficiario/pagador",
  "requestOrderFiles": "solicitó archivos",
  "reviseOrderLedger": "pidió revisión contable",
  "updateOrderArchive": "actualizó información de archivo",
  "updateOrderCash": "actualizó el efectivo a cerrar",
  "updateOrderCommmitment": "actualizó la información de compromiso",
  "updateOrderConfiguration": "actualizó la configuración de la orden",
  "updateOrderFile": "actualizó información de archivo",
  "updateOrderLedgerAssociation": "actualizó una asociación de libro mayor",
  "updateOrderLedgerEntry": "actualizó una entrada en el libro mayor",
  "updateOrderLoan": "actualizó información del préstamo",
  "updateOrderMortgage": "actualizó información de la hipoteca",
  "updateOrderPolicy": "actualizó información de la póliza",
  "updateOrderProperty": "actualizó información de la propiedad",
  "updateOrderProration": "actualizó información de impuestos o prorrateo",
  "updateOrderSpecifics": "actualizó información específica",
  "updateOrderTokens": "actualizó los tokens de acceso",
  "workerAccountAddition": "agregó información de cuenta cifrada",
  "workerAccountRemoval": "eliminó información de cuenta cifrada",
  "workerAccountingLedger": "regeneró la hoja de cálculo contable",
  "workerDocumentGenerator": "regeneró contenido para todos los archivos",
  "workerFrostAuthorization": "registró una autorización de transferencia bancaria",
  "workerFrostRecords": "generó registros de transferencia bancaria",
  "workerFrostRequest": "inició un proceso de transferencia bancaria",
  "workerFrostSubmission": "envió registros de transferencia bancaria",
  "workerLoadNarrative": "redactó la narrativa de la orden",
  "workerTagReplacer": "reemplazó etiquetas de plantilla",
  "createAddress": "agregó una dirección",
  "createAutoTemplate": "agregó una plantilla automática",
  "createChargeSetting": "agregó una configuración de cargo",
  "createEmail": "agregó un correo electrónico",
  "createLicense": "agregó una licencia",
  "createNotification": "agregó una notificación",
  "createParty": "agregó una partida",
  "createPartyAssociation": "asoció una partida",
  "createPartyPayment": "agregó un pago de partida",
  "createPhone": "agregó un número telefónico",
  "createTransferRequest": "creó una solicitud de transferencia",
  "createUser": "creó un usuario",
  "deleteAddress": "eliminó una dirección",
  "deleteAutoTemplate": "eliminó una plantilla automática",
  "deleteChargeSetting": "eliminó una configuración de cargo",
  "deleteEmail": "eliminó un correo electrónico",
  "deleteLicense": "eliminó una licencia",
  "deleteNotification": "eliminó una notificación",
  "deleteParty": "eliminó una partida",
  "deletePartyAssociation": "desasoció una partida",
  "deletePartyPayment": "eliminó un pago de partida",
  "deletePhone": "eliminó un número telefónico",
  "deleteUser": "eliminó un usuario",
  "helpOrderLinkedEntry": "usó el asistente para enlazar una entrada",
  "mergeDocuments": "combinó documentos",
  "requestNetworkAccess": "solicitó acceso a la red",
  "requestSignature": "solicitó una firma",
  "resetPassword": "restableció una contraseña",
  "sendNotification": "envió una notificación",
  "updateAddress": "actualizó una dirección",
  "updateAutoTemplate": "actualizó una plantilla automática",
  "updateChargeSetting": "actualizó una configuración de cargo",
  "updateEmail": "actualizó un correo electrónico",
  "updateLicense": "actualizó una licencia",
  "updateLocalPassword": "actualizó la contraseña local",
  "updateNotification": "actualizó una notificación",
  "updateOrderCommitment": "actualizó la información de compromiso",
  "updateOrderLedgerPosted": "actualizó la fecha de publicación del libro mayor",
  "updateOrderLedgerStatus": "actualizó el estado del libro mayor",
  "updateOrderProjected": "actualizó los montos proyectados",
  "updateParty": "actualizó información de la partida",
  "updatePartyNotifications": "actualizó notificaciones de la partida",
  "updatePhone": "actualizó un número telefónico",
  "updateUserNotes": "actualizó notas del usuario",
  "updateOrderFileData": "actualizó información de archivo",
  "createOrderNote": "agregó una nota",
  "updateOrderNote": "actualizó una nota",
  "deleteOrderNote": "eliminó una nota",
  "helpOrderLedgerEntryParties": "usó el asistente para establecer las partes de una entrada del libro mayor",
  "deleteOrderLedgerRole": "eliminó un rol del libro mayor",
  "createAssociation": "asoció una partida",
  "deleteAssociacion": "desasoció una partida",
  "createNewProperty": "agregó una propiedad",
  "deleteProperty": "eliminó una propiedad",
  "updateProperty": "actualizó información de la propiedad"
}
